import { Button, Checkbox, FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import withStyles from "@material-ui/core/styles/withStyles"
import moment from 'moment'
import React, { useEffect, useState } from "react"
import copy from '../../constants/copy.json'
import { advSource, appartment, leads, reserveAppointments, searchAppointments } from "../../constants/endpoints.jsx"
import CheckboxIcon from '../../images/icons/Checkbox'
import homeStyle from "../Home/homeStyle"
import Loader from '../Loader/Loader'
import PickAppointment from './PickAppointment'
import Slots from './Slots'
import { PrivacyPdf } from '../../constants/links'





const ContactProject = ({ classes, residenza }) => {

  const [source, setSource] = useState([]);
  const [appartmentType, setAppartmentType] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(false);

  const UrlParametersToSend = {};

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const entries = urlParams.entries();
    for (const entry of entries) {
      UrlParametersToSend[entry[0]] = entry[1];
    }
  }, [UrlParametersToSend]);

  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    title: copy.home.form.error,
    subtitle1: '',
    subitle: '',
  });

  const [success, setSuccess] = useState(false);
  const [pickApp, setPickApp] = useState(false);

  const [daySelected, setDaySelected] = useState(moment().startOf('day').add(1, 'days'));
  const [leadId, setLeadId] = useState(null);
  const [slot, setSlot] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);

  const [data, setData] = useState(
    {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      consent1: false,
      consent2: false,
      consent4: false,
      subject: '',
      body: '',
      advertisingSource: '',
      city: '',
      contact: ''
    });

  useEffect(() => {
    fetch(advSource, {
      method: "get",
      headers: {
        'Accept': '*/*',
        "Content-Type": "application/json"
      }
    })
      .then(results => {
        return results.json();
      })
      .then(response => {
        var responseCode = response.statusCode;
        if (responseCode !== 200 && responseCode !== 401) {
          console.error(
            "Error calling " + advSource + ": " + response.error.type + "\n\n" + response.error.description
          );
        } else {
          setSource(response.data);
        }
      });

    fetch(appartment, {
      method: "get",
      headers: {
        'Accept': '*/*',
        "Content-Type": "application/json"
      }
    })
      .then(results => {
        return results.json();
      })
      .then(response => {
        var responseCode = response.statusCode;
        if (responseCode !== 200 && responseCode !== 401) {
          console.error(
            "Error calling " + appartment + ": " + response.error.type + "\n\n" + response.error.description
          );
        } else {
          setAppartmentType(response.data);
        }
      });
  }, [residenza]);


  useEffect(() => {
    if (daySelected && leadId) {
      const duration = residenza.acfResidenza.durataSlotAppuntamentoMapadore ?? 90;
      searchApp(leadId, daySelected.valueOf(), residenza.acfResidenza.groupId, residenza.acfResidenza.buildingId, residenza.acfResidenza.projname, 1, duration);
    }
  }, [daySelected, leadId, residenza.acfResidenza.groupId, residenza.acfResidenza.buildingId, residenza.acfResidenza.projname, residenza.acfResidenza.durataSlotAppuntamentoMapadore]);

  const handleChangeData = (param, e) => {
    const dataUpdate = data;
    if (param === 'consent1' || param === 'consent2' || param === 'consent4') {
      dataUpdate[param] = e.target.checked;
    } else {
      dataUpdate[param] = e.target.value;
    }
    setData(dataUpdate);
  };

  const searchApp = (leadId, startTimestamp, operatorId, constructionSiteId, projectName, dayRange, duration) => {
    setSuccess(false);
    setError(false);
    setLoading(true);
    setSlot([]);
    fetch(`${searchAppointments}?leadId=${leadId}&startTimestamp=${startTimestamp}&dayRange=${dayRange}&duration=${duration}&operatorId=${operatorId}&constructionSiteId=${constructionSiteId}&projectName=${projectName}`, {
      method: "get",
      headers: {
        'Accept': '*/*',
        "Content-Type": "application/json"
      },
    })
      .then(results => {
        return results.json();
      })
      .then(response => {
        var responseCode = response.statusCode;
        if (responseCode !== 200 && responseCode !== 401) {
          console.error(
            "Error calling " + searchAppointments + ": " + response.error.type + "\n\n" + response.error.description
          );
          setError(true);
          setLeadId(null);
          setLoading(false);
        } else if (response.data.scheduledEvents.some(scheduledEvent => moment(scheduledEvent.start_time).isAfter(moment()))) {
          setErrorMessage(copy.progetti.projectPage.alreadyScheduledEventError);
          setError(true);
          setSubmitButtonDisabled(true);
          setLeadId(null);
          setLoading(false);
        } else {
          const slots = response.data.results
            .filter((item) => item.is_range)
            .map((result) => ({
              appointment: {
                location: {
                  target_address: result.target_address,
                  latitude: result.latitude,
                  longitude: result.longitude,
                },
                time: {
                  startTime: result.start_time,
                  finishTime: result.finish_time,
                },
                mapadore_event_id: result.mapadore_event_id,
                operator_id: result.operator_id,
                operator_name: result.operator_name,
                target_id: result.target_id,
              },
            }));
          /*.filter(
            (element) => moment(element.appointment.time.startTime).isSame(daySelected, 'day')
          );*/
          setSlot(slots);
          setPickApp(true);
          setLoading(false);
        }
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setError(false);
    setSuccess(false);
    setLoading(true);

    const body = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone,
      consent1: data.consent1,
      consent2: data.consent2,
      consent4: data.consent4,
      advertisingSource: data.advertisingSource,
      constructionSiteId: residenza.acfResidenza.buildingId,
      projectId: residenza.acfResidenza.projectId,
      numberOfRoom: data.subject,
    };

    fetch(leads, {
      method: "post",
      headers: {
        'Accept': '*/*',
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(results => {
        return results.json();
      })
      .then(response => {
        var responseCode = response.statusCode;
        if (responseCode !== 200 && responseCode !== 401) {
          console.error(
            "Error calling " + leads + ": " + response.error.type + "\n\n" + response.error.description
          );
          setError(true);
          setLoading(false);
        } else {
          setLeadId(response.data.id);
          setLoading(false);
        }
      });
  };

  const handleDaySelected = (day) => {
    setSuccess(false);
    setError(false);
    setDaySelected(day);
    setSelectedSlot(null);
  };

  const handleConfirmSlot = () => {
    setSuccess(false);
    setError(false);
    setLoading(true);
    setSuccess(false);

    const body = {
      "targetId": selectedSlot.appointment.target_id,
      "targetAddress": selectedSlot.appointment.location.target_address,
      "startTime": selectedSlot.appointment.time.startTime,
      "finishTime": selectedSlot.appointment.time.finishTime,
      "latitude": selectedSlot.appointment.location.latitude,
      "longitude": selectedSlot.appointment.location.longitude,
      "mapadoreEventId": selectedSlot.appointment.mapadore_event_id,
      "operatorId": selectedSlot.appointment.operator_id,
      "constructionSiteId": residenza.acfResidenza.buildingId,
      "advertisingSource": data.advertisingSource
    };

    if (UrlParametersToSend) {
      body["utm"] = UrlParametersToSend;
    }

    fetch(`${reserveAppointments}`, {
      method: "post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(results => {
        return results.json();
      })
      .then(response => {
        var responseCode = response.statusCode;
        if (responseCode !== 200 && responseCode !== 401) {
          console.error(
            "Error calling " + searchAppointments + ": " + response.error.type + "\n\n" + response.error.description
          );
          setError(true);
          setLoading(false);

          if (response.error.type === 'TIME_ALREADY_ALLOCATED') {
            setErrorMessage({
              subtitle1: 'Purtoppo sei arrivato tardi!',
              subtitle2:
                'Qualcun altro ha appena preso un appuntamento per questa fascia oraria.',
              title:
                'Per favore prova a cambiare orario o giorno',
            });
          } else {
            setErrorMessage({
              title: copy.home.form.error,
              subtitle1: '',
              subitle2: '',
            });
          }
        } else {

          const emptyData = {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            consent1: false,
            consent2: false,
            consent4: false,
            subject: '',
            body: '',
            advertisingSource: '',
            city: '',
            contact: ''
          };
          setData(emptyData);
          setPickApp(false);
          setSuccess(true);
          setLoading(false);
        }
      });
  };

  return (
    <Grid container direction='column' justify='center' alignItems='center' className={classes.contactContainer}>
      <Grid item justify='center' align='center' className={classes.logoContainer} >
        <img className={classes.logo} src={residenza.acfResidenza.logo && residenza.acfResidenza.logo.sourceUrl} alt="" />
      </Grid>
      <Grid item className={classes.subTitle + ' ' + classes.titleDark}>
        {copy.home.form.titleProj}
      </Grid>
      {loading && !pickApp && <Loader color='dark' />}
      {error && !loading &&
        <Grid container item justify='center' alignContent='center' direction='column'>
          <Grid container item className={classes.subTitle + ' ' + classes.error} justify='center'>
            {errorMessage.subtitle1}
          </Grid>
          <Grid container item className={classes.subTitle + ' ' + classes.error} justify='center'>
            {errorMessage.subtitle2}
          </Grid>
          <Grid container item className={classes.subTitle + ' ' + classes.error} justify='center'>
            {errorMessage.title}
          </Grid>
        </Grid>}
      {success && !loading &&
        <Grid container className={classes.subTitle + ' ' + classes.titleDark} direction='row' justify='center' style={{ margin: '30px' }}>
          <Grid item>
            <CheckboxIcon dimension='30px' color='#353535' />
          </Grid>
          <Grid item style={{ alignSelf: 'flex-end', fontSize: '30px', fontWeight: 'bold' }}>
            {copy.home.form.success}
          </Grid>
        </Grid>}
      {pickApp &&
        <>
          <PickAppointment weekInterval={5} daySelected={daySelected} setDaySelected={(day) => handleDaySelected(day)} />
          <Slots loading={loading} slots={slot} daySelected={daySelected} selectedSlotId={selectedSlot && selectedSlot.appointment.mapadore_event_id} setSelectedSlot={setSelectedSlot} handleConfirmSlot={() => handleConfirmSlot()} />
        </>
      }
      {!pickApp && !loading &&
        <form onSubmit={handleSubmit}>
          <Grid container>
            <FormControl classes={{ root: classes.formControlRoot }}>
              <Grid container direction='row'>
                <Grid container item xs={12} sm={6} direction='column' className={classes.contactSection1}>
                  <TextField
                    label={copy.home.form.nome}
                    onChange={(e) => handleChangeData('firstName', e)}
                    defaultValue={data.firstName}
                    required
                    classes={{ root: classes.textFieldRoot }}
                    InputLabelProps={{
                      classes: {
                        root: classes.inputContactPropsRoot
                      }
                    }}
                    InputProps={{
                      classes: {
                        root: classes.inputContactPropsRoot,
                        underline: classes.contactTextFieldFocused
                      }
                    }} />
                  <TextField
                    label={copy.home.form.cognome}
                    onChange={(e) => handleChangeData('lastName', e)}
                    defaultValue={data.lastName}
                    required
                    classes={{ root: classes.textFieldRoot }}
                    InputLabelProps={{
                      classes: {
                        root: classes.inputContactPropsRoot
                      }
                    }}
                    InputProps={{
                      classes: {
                        root: classes.inputContactPropsRoot,
                        underline: classes.contactTextFieldFocused
                      }
                    }} />
                  <TextField
                    label={copy.home.form.email}
                    type='email'
                    onChange={(e) => handleChangeData('email', e)}
                    defaultValue={data.email}
                    required
                    classes={{ root: classes.textFieldRoot }}
                    InputLabelProps={{
                      classes: {
                        root: classes.inputContactPropsRoot
                      }
                    }}
                    InputProps={{
                      classes: {
                        root: classes.inputContactPropsRoot,
                        underline: classes.contactTextFieldFocused
                      }
                    }} />
                  <TextField
                    label={copy.home.form.tel}
                    defaultValue={data.phone}
                    type='tel'
                    onChange={(e) => handleChangeData('phone', e)}
                    required
                    classes={{ root: classes.textFieldRoot }}
                    InputLabelProps={{
                      classes: {
                        root: classes.inputContactPropsRoot
                      }
                    }}
                    inputProps={{ pattern: "^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-/0-9]*$" }}
                    InputProps={{
                      classes: {
                        root: classes.inputContactPropsRoot,
                        underline: classes.contactTextFieldFocused
                      }
                    }} />
                  <TextField
                    label={copy.home.form.comune}
                    onChange={(e) => handleChangeData('city', e)}
                    defaultValue={data.city}
                    required
                    classes={{ root: classes.textFieldRoot }}
                    InputLabelProps={{
                      classes: {
                        root: classes.inputContactPropsRoot
                      }
                    }}
                    InputProps={{
                      classes: {
                        root: classes.inputContactPropsRoot,
                        underline: classes.contactTextFieldFocused
                      }
                    }} />
                </Grid>
                <Grid container item xs={12} sm={6} direction='column' className={classes.contactSection2}>
                  <FormControl required>
                    <InputLabel id="subject" classes={{
                      root: classes.inputContactPropsRoot,
                      formControl: classes.formControl
                    }}>
                      {copy.home.form.interested}
                    </InputLabel>
                    <Select
                      labelId="subject"
                      onChange={(e) => handleChangeData('subject', e)}
                      defaultValue={data.subject}
                      required
                      className={classes.select + ' ' + classes.underlinedInput}
                      inputProps={{
                        classes: {
                          root: classes.inputContactPropsRoot
                        }
                      }}
                    >
                      {appartmentType && appartmentType.map((item, idx) => (
                        <MenuItem key={idx} className={classes.inputContactPropsRoot} value={item.code}>{item.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl required>
                    <InputLabel id="advSource" classes={{
                      root: classes.inputContactPropsRoot,
                      formControl: classes.formControl
                    }}>
                      {copy.home.form.source}
                    </InputLabel>
                    <Select
                      labelId="advSource"
                      onChange={(e) => handleChangeData('advertisingSource', e)}
                      defaultValue={data.advertisingSource}
                      required
                      className={classes.select + ' ' + classes.underlinedInput}
                      inputProps={{
                        classes: {
                          root: classes.inputContactPropsRoot
                        }
                      }}
                    >
                      {source && source.map((item, idx) => (
                        <MenuItem key={idx} className={classes.inputContactPropsRoot} value={item.code}>{item.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {/*<FormControl required>
                      <InputLabel id="contact" classes={{
                            root: classes.inputContactPropsRoot,
                            formControl: classes.formControl
                          }}>
                        {copy.home.form.contact}
                      </InputLabel>
                      <Select
                        labelId="contact"
                        onChange={(e) => handleChangeData('contact', e)}
                        defaultValue={data.contact}
                        required
                        className={classes.select + ' ' + classes.underlinedInput}
                        inputProps={{
                          classes: {
                            root: classes.inputContactPropsRoot
                          }
                        }}
                        >
                          <MenuItem className={classes.inputContactPropsRoot} value='video'>Appuntamento video</MenuItem>
                          <MenuItem className={classes.inputContactPropsRoot} value='telefono'>Appuntamento telefonico</MenuItem>
                      </Select>
                    </FormControl>*/}
                  <Grid container direction='row' spacing={1}>
                    <Grid item xs={12} className={classes.checkBoxLabel}>
                      {copy.home.form.privacy} <a className={classes.checkBoxLabel + ' ' + classes.checkBoxLabelLink} href={PrivacyPdf} target="_blank" rel="noreferrer">{copy.home.form.privacyLink}</a>
                    </Grid>
                    <Grid item xs={2} md={1}>
                      <Checkbox
                        required={true}
                        name="consent1"
                        onChange={(e) => handleChangeData('consent1', e)}
                        defaultValue={data.consent1 || false}
                        checkedIcon={<div className={classes.checkedIcon}>
                          <CheckboxIcon dimension='13px' color='white' top='-5px' />
                        </div>}
                        icon={<div className={classes.icon} />}
                        classes={{
                          root: classes.checkBoxRoot
                        }}
                      />
                    </Grid>
                    <Grid item xs={10} md={11} className={classes.checkBoxLabel}>
                      {copy.home.form.check1}
                    </Grid>
                  </Grid>
                  <Grid container direction='row' spacing={1}>
                    <Grid item xs={2} md={1}>
                      <Checkbox
                        name="consent2"
                        onChange={(e) => handleChangeData('consent2', e)}
                        defaultValue={data.consent2 || false}
                        checkedIcon={<div className={classes.checkedIcon}>
                          <CheckboxIcon dimension='13px' color='white' top='-5px' />
                        </div>}
                        icon={<div className={classes.icon} />}
                        classes={{
                          root: classes.checkBoxRoot
                        }}
                      />
                    </Grid>
                    <Grid item xs={10} md={11} className={classes.checkBoxLabel}>
                      {copy.home.form.check2}
                    </Grid>
                  </Grid>
                  <Grid container direction='row' spacing={1}>
                    <Grid item xs={2} md={1}>
                      <Checkbox
                        name="consent4"
                        onChange={(e) => handleChangeData('consent4', e)}
                        defaultValue={data.consent4 || false}
                        checkedIcon={<div className={classes.checkedIcon}>
                          <CheckboxIcon dimension='13px' color='white' top='-5px' />
                        </div>}
                        icon={<div className={classes.icon} />}
                        classes={{
                          root: classes.checkBoxRoot
                        }}
                      />
                    </Grid>
                    <Grid item xs={10} md={11} className={classes.checkBoxLabel}>
                      {copy.home.form.check3}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </FormControl>
          </Grid>
          <Grid container justify='center'>
            <Button type='submit' classes={{ root: classes.greyButton, disabled: classes.greyButtonDisabled }} disabled={isSubmitButtonDisabled}>
              {copy.home.form.submitMapadore}
            </Button>
          </Grid>
        </form>
      }
    </Grid>
  )
}

export default withStyles(homeStyle)(ContactProject)
